//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// header imports
import { IStandardProps, IMoreInfoProps, ISubHeaderProps } from "./SuggestionCardHeader.d";
import { standardStyles as s } from "./SuggestionCardHeader.styles";
// other components
import { A, H2 } from "@ui";
import { CardTopLine } from "@components/card-top-line";
// util
import { processSubheading } from "@util/suggestion.util";
import { track } from "@util/analytics.util";

////////////////////////////
// MORE INFO LINK COMPONENT
///////////////////////////
const MoreInfoLink = ({ link, trackingInfo }: IMoreInfoProps) => {
  if (!link) {
    return <span />;
  }

  const onLearnMore = () => {
    if (trackingInfo) {
      track(trackingInfo);
    }
  };

  return (
    <span>
      &nbsp;
      <A href={link} target="_blank" onClick={onLearnMore}>
        Learn more
      </A>
    </span>
  );
};

////////////////////////////
// SUBHEADING COMPONENT
///////////////////////////
const SuggestionCardSubHeading = ({
  text,
  suggestionType,
  moreInfoLink,
  moreInfoTracking,
}: ISubHeaderProps) => {
  const subheadingStrings = processSubheading(suggestionType, text);

  if (subheadingStrings.length === 0) {
    return <span />;
  }

  return (
    <div style={s.subHeading}>
      {subheadingStrings.map(({ text: textPart, styles }, i) => {
        return (
          <span key={i} style={styles}>
            {textPart}
          </span>
        );
      })}
      <MoreInfoLink link={moreInfoLink} trackingInfo={moreInfoTracking} />
    </div>
  );
};

////////////////////////////
// PRIMARY COMPONENT
///////////////////////////
export const SuggestionCardHeaderStandard = ({
  label,
  moreInfoLink,
  moreInfoTracking,
  occurredMillis,
  removeCard,
  suggestionType,
  text,
}: IStandardProps) => {
  return (
    <div style={s.container}>
      <div style={s.topLine}>
        <CardTopLine timeStamp={occurredMillis} clear={removeCard} label={label} />
      </div>
      <div style={s.body}>
        <H2>{text.title}</H2>
        <SuggestionCardSubHeading
          moreInfoTracking={moreInfoTracking}
          suggestionType={suggestionType}
          moreInfoLink={moreInfoLink}
          text={text}
        />
      </div>
    </div>
  );
};
